// extracted by mini-css-extract-plugin
export default {"transformation":"transformation---pKwqM"};